<script setup>
import {ref, inject} from "vue";
import {getNoun} from "../../../helpers/string";
import MatchMakingModal from "@/views/needs/need/matchMaking/MatchMakingModal.vue";

const need = inject('need');
const getInfo = inject('getInfo');

const matchMakingModal = ref(null);
</script>

<template>
    <div>
        <header class="card-needs__header">
            <h3 class="heading3 heading3--match">New Matches</h3>
        </header>

        <div class="card-needs__content">
            <div class="row">
                <div v-if="need.unreviewed_startups_count" class="col">
                    <div class="card-headline">
                        <div class="card-headline__content">
                            <div class="card-needs__notification card-needs__notification--active">
                                <img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" />
                            </div>

                            <div class="text-center">
                                <div class="card-needs__plate">{{need.unreviewed_startups_count}} new AI {{getNoun('recommendation')}}</div>
                            </div>
                        </div>

                        <footer class="card-headline__footer">
                            <a @click="matchMakingModal?.open()" class="link-arrow justify-content-end">Review</a>
                        </footer>
                    </div>
                </div>

                <div class="col">
                    <div class="card-headline">
                        <div class="card-headline__content">
                            <div class="card-needs__notification card-needs__notification--active">
                                <img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" />
                            </div>

                            <div class="text-center">
                                <div class="card-needs__plate">NEA sent 6 solutions</div>
                            </div>
                        </div>
                        <footer class="card-headline__footer">
                            <a href="#" class="link-arrow justify-content-end">Review</a>
                        </footer>
                    </div>
                </div>
            </div>
        </div>

        <MatchMakingModal
            ref="matchMakingModal"
            @updated="getInfo"
        />
    </div>
</template>

<style scoped>

</style>
